import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import auth from '../marketplace/store/auth';
import marketplace from '../marketplace/store/marketplace';
import designspec from '../marketplace/store/designspec';

Vue.use(Vuex)
;(function() {
  if (typeof window.CustomEvent === 'function') return false; //If not IE

  function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    const evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(
      event,
      params.bubbles,
      params.cancelable,
      params.detail
    );
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

const broadcast = store => {
  store.subscribe((_mutation, state) => {
    const event = new CustomEvent('vuex-sync', {
      detail: JSON.parse(JSON.stringify(state))
    });
    document.dispatchEvent(event);
  });

  document.addEventListener('vuex-sync', ({detail}) => {
    if (JSON.stringify(store.state) !== JSON.stringify(detail)) {
      store.replaceState(detail);
    }
  });

  window.addEventListener('storage', ({key, newValue}) => {
    if (key === 'vuex') {
      const data = JSON.parse(newValue || '{}');
      store.replaceState(data);
    }
  });
  return store;
};

const persist = new VuexPersist({
  key: 'vuex',
  storage: window.localStorage,
  reducer: state => {
    // eslint-disable-next-line no-unused-vars
    const {isMiniCartOpen, ...marketplaceState} = state.marketplace;

    return {
      auth: state.auth,
      marketplace: marketplaceState,
      designspec: state.designspec
    };
  }
});

export default new Vuex.Store({
  modules: {
    auth,
    marketplace,
    designspec
  },
  plugins: [broadcast, persist.plugin]
});
